module.exports = __webpack_public_path__ + "img/browser.a0213848.png";